<template>
    <!-- 筛选 -->
    <div class="screen">
        <div class="item clearfix">
            <!-- <span class="zu clearfix">
                <span class="name">媒体类别</span>
                <span class="drop-down">
                    <button class="btn btn-lightblue"><span class="text">{{platformCondition != '' ? platformCondition : '全部'}}</span><i class="icons"></i></button>
                    <ul class="option">
                        <li v-for="(item,index) in mediaList" :key="index" @click="mediaSelect(item);">{{item}}</li>
                    </ul>
                </span>
            </span> -->
            <span class="zu clearfix">
                <span class="d-flex">
                    <span class="name">媒体类别</span>
                    <platTypeCascader title="媒体类别" :industryTypeList="mediaLevelList" :morenzhi="morenzhi" @putData="putData"></platTypeCascader>
                </span>
            </span>
            <span class="zu clearfix">
                <span class="name">定向信源</span>
                <span class="drop-down">
                    <button class="btn btn-lightblue"><span class="texts">{{xinYuanList[source]}}</span><i class="icons"></i></button>
                    <ul class="option">
                        <li v-for="(item,index) in xinYuanList" @click="xinYuanSelect(index)" :key="index">{{item}}</li>
                    </ul>
                </span>
            </span>
            <span class="zu clearfix">
                <span class="name">发布地区</span>
                <city @cityCallback="citySelect" ref="myCity" levels="3"></city>
            </span>
        </div>
        <div class="item clearfix">
            <span class="zu clearfix">
                <span class="name">时间范围</span>
                <div class="clearfix fl">
                    <div class="corm fl">
                        <a class="element" :class="{curr:timeType===5}" href="javascript:void(0)" @click="selectFixedTime(5,1);">24小时</a>
                        <a class="element" :class="{curr:timeType===0}" href="javascript:void(0)" @click="selectFixedTime(0,1);">今天</a>
                        <a class="element" :class="{curr:timeType===1}" href="javascript:void(0)" @click="selectFixedTime(1,1);">昨天</a>
                        <a class="element" :class="{curr:timeType===2}" href="javascript:void(0)" @click="selectFixedTime(2,1);">近三天</a>
                        <a class="element" :class="{curr:timeType===3}" href="javascript:void(0)" @click="selectFixedTime(3,1);">近七天</a>
                        <a class="element" :class="{curr:timeType===4}" href="javascript:void(0)" @click="selectFixedTime(4,1);">自定义</a>
                    </div>
                    <vue-datepicker-local v-if="timeType === 4" class="fl" v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" :disabledDate="disabledDate" show-buttons  @confirm="selectedDate"/>
                </div>
            </span>
        </div>
        <div class="item clearfix">
            <span class="name">媒体类型</span>
            <div class="screen-list" v-if="afromType === '1'">
                <div class="corm clearfix">
                    <span class="element" v-for="(item,index) in MediaPlatformList" :key="index" :class="luyou === item.type ? 'curr' : ''" @click="chooseMedia(item.type);">{{item.name}}</span>
                </div>
            </div>
            <div class="screen-list" v-else>
                <div class="corm clearfix">
                    <span v-for="(item,index) in MediaPlatformList" :key="index" >
                        <router-link v-if="item.children.length == 0" class="element" :class="luyou === item.type ? 'curr' : ''" :to="{path:`${item.name == '全部'?'/analysis':'/analysis/allAnalysis'}`+item.path+'?type='+item.type}">{{item.name}}</router-link>
                        <span v-else class="element drop-down" :class="{curr:$route.path === $parent.$parent.baseUrl+item.path}">
                            <button class="btn"><span class="text">{{item.name}}</span><i class="icons"></i></button>
                            <ul class="option">
                                <li data-show="no" v-for="(items,indexs) in item.children" :key="indexs" ><router-link class="db" :to="{path:'/analysis/allAnalysis'+item.path+'?type='+items.type}">{{items.name}}</router-link></li>
                            </ul>
                        </span>
                    </span>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex';
import city from '../../../components/city.vue';
import platTypeCascader from '../../../components/platTypeCascader.vue';
import VueDatepickerLocal from 'vue-datepicker-local'
export default {
    components:{city,VueDatepickerLocal,platTypeCascader},
    computed:{
        ...mapState({
            mediaLevelList: state => state.show.companyinfo.mediaLevelList,
            MediaPlatformList: state => state.show.companyinfo.platformList,
        })
    },
    props:{
        afromType:{
            type:String,
            default:''
        }
    },
    data() {
        const min = new Date(2017, 5, 1, 0, 0)
        const max = new Date(2017, 8, 30, 0, 0)
        return {
            platformCondition:'',//平台条件
            jianRegion:'全国',//地区
            luyou:'total',//当前页面路由
            planId:'',//方案ID
            timeType:3,//时间乐类型
            mediaList:['全部','政府','媒体','个人','其他'],//媒体字段
            timeRange: [min, max],//时间
            xinYuanList:['全部','重点关注'],//信源选项列表
            source:0,//信源值
            morenzhi:{},
            platformType:[]//平台数据
        }
    },
    mounted() {
        let that = this;
        that.$nextTick(()=> {
            that.luyou = that.$route.query.type?that.$route.query.type:'total';//获取当前页面url的type
            let sdf = JSON.parse(sessionStorage.getItem('myInfor'));//获取储存筛选条件
            that.initialCondition(sdf);
            //that.getPlatformType();
            that.getShieldWords();
            // 获取本地的省份
            this.$axios.get('/static/city.json').then((r) => {
                that.$parent.provinceList = r.data.shortProvince;
            })
        })
    },
    watch: {
        $route(){
            this.luyou = this.$route.query.type;//获取当前页面url的type
        }
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        //获取选中的方案e
        putData(e){
           //console.log(e)e
            this.$parent.mediaLevel = e;
            this.platformCondition = e;//存储平台参数
            this.conditionSave();
            this.morenzhi = e;
            //数据加载
            this.$parent.endDate_ = this.$utils.getNowDate();
            this.$parent.dataAjax();
        },
        //切换媒体
        chooseMedia(type){
            this.luyou = type;
            this.$parent.endDate_ = this.$utils.getNowDate();
            this.$parent.platformType = type; 
        },
        //页面初始条件
        initialCondition(sdf) {
            let that = this;
            let max = '';
            let min = '';
            let timeType = '';
            if(sdf == null){//暂无sessionStorage数据
                this.selectFixedTime(0,0);
            }else{//存在sessionStorage数据
                let pt = sdf.pt;//获取平台数据
                let dq = sdf.dq;
                let time = sdf.time;//获取时间数据
                timeType = sdf.timeType;//获取时间筛选类型
                if(timeType === undefined || timeType === ''){
                    timeType = 3;
                }
                if(pt != ''){
                    that.$parent.mediaLevel = pt;
                    that.platformCondition = pt;
                }
                if(dq){
                    this.jianRegion = dq;
                    this.$refs.myCity.simpleName = dq;//给城市组件赋值
                    this.$parent.pubArea = dq;
                    this.$parent.curMapName = dq;
                }
                if(time != ''){
                   let start = time[0];
                   let end = time[1];
                   min = that.dateSplit(start);
                   max = that.dateSplit(end);
                }
				this.source = sdf.isFocus;
				this.timeRange = [min,max];
                this.selectFixedTime(timeType,0);
            }
            // this.timeRange = [min,max];
            //进页面获取时间数据
            // if(timeType === 4){
            //     that.timeType = timeType;
            //     this.$parent.startDate = this.$utils.dateConversion(min,1);
            //     this.$parent.endDate = this.$utils.dateConversion(max,1);
            // }else{
                
            // }
        },
        // 时间拆分
        dateSplit (date) {
            let zu = date.split(' ');
            let qian = zu[0].split('-');
            let hou = zu[1].split(':');
            let value = new Date(qian[0], parseInt(qian[1])-1, parseInt(qian[2]), parseInt(hou[0]), parseInt(hou[1]), parseInt(hou[2]));
            return value;
        },
        // 固定时间选择
        selectFixedTime (type,selectType) {//type 0是今天 1是昨天 2是近三天 3是近7天 4是自定义 selectType是点击还是一进页面判断
            let that = this;
            if(type === that.timeType && selectType === 1){
                return;
            }
            let nowTime = this.$utils.getNowDate();//今天时间
            let n = nowTime.split(' ')[1].split(':');//拆分当前时分秒
            let h = n[0]; 
            let m = n[1]; 
            let s = n[2]; 
            let min = '';
            let max = '';
            that.timeType = type;
            if(type === 0){
                min = nowTime.split(' ')[0] + ' ' + '00:00:00';
                max = nowTime;
            }else if(type === 1){
                let yesterday = this.$utils.getBeforeDay(nowTime,1);//前一天
                min = yesterday + ' ' + '00:00:00';
                max = yesterday + ' ' + '23:59:59';
                this.$parent.allDataType = 'solid';//昨天的时候要重置父组件数据汇总显示趋势图
            }else if(type === 2){
                let ptd = this.$utils.getBeforeDay(nowTime,3);//前三天
                min = ptd + ' ' + '00:00:00';
                max = nowTime;
            }else if(type === 3){
                let ptd = this.$utils.getBeforeDay(nowTime,7);//前三天
                min = ptd + ' ' + '00:00:00';
                max = nowTime;
                console.log(min,max)
            }else if(type === 5){
                let ptd = this.$utils.getBeforeDay(nowTime,1);//24小时
                min = ptd + ' ' + h + ':' + m + ':' + s;
                max = nowTime;
            }else if(type === 4){
                // 获取当前时间和7天前时间
                let sdf = JSON.parse(sessionStorage.getItem('myInfor'));
                if(sdf.time === ''){//自定义时已选择时间
                    let ptd = this.$utils.getBeforeDay(nowTime,7);//前三天
                    min = ptd + ' ' + '00:00:00';
                    max = nowTime;
                }else{
                    min = sdf.time[0];
                    max = sdf.time[1];
                }
            }
            let ns = max.split(' ');//时间拆分
            let n1 = ns[0].split('-');
            let n2 = ns[1].split(':');
            let o1 = (min.split(' ')[0]).split('-');
            let o2 = (min.split(' ')[1]).split(':');
            let max1 = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            let min1 = new Date(o1[0], o1[1]-1, o1[2], o2[0], o2[1], o2[2])
            this.timeRange = [min1,max1];
            //进页面获取时间数据
            that.$parent.startDate = min;
            that.$parent.endDate = max;
            // that.timeRange = [min,max];
            if(selectType === 1){//点击选择时
                that.$parent.dataAjax();
                that.$parent.endDate_ = null;
            }
            that.conditionSave();
        },
        //获取平台类型
        // getPlatformType () {
        //     let that = this;
        //     that.$api.post('monitor/analysis/platform', null, r => {
        //         that.$utils.returnCode(r,function(){
        //             let data = r.data;
        //             that.platformType = data;
        //         });  
        //     })
        // },
        //城市选择
        citySelect (name) {
            this.$parent.pubArea = name;
            this.jianRegion = name;//存储省份参数
            this.conditionSave();
            //数据加载
            this.$parent.curMapName = name;
            this.$parent.endDate_ = this.$utils.getNowDate();
            this.$parent.dataAjax();
        },
        // 信源筛选
        xinYuanSelect (index){
            this.source = index;
            this.conditionSave();
            this.$parent.endDate_ = this.$utils.getNowDate();
            //数据加载
            this.$parent.dataAjax();
        },
        // 时间选择
        selectedDate () {
            let timeRange = this.timeRange;
            //进页面获取时间数据
            this.$parent.startDate = this.$utils.dateConversion(timeRange[0],1);
            this.$parent.endDate = this.$utils.dateConversion(timeRange[1],1);
            let day = this.$utils.getDateDiff(this.$parent.startDate,this.$parent.endDate);
            if(day > this.$parent.$parent.timeSection){
                this.$utils.alertText('时间跨度最大限制'+this.$parent.$parent.timeSection+'天','',1500);
                return;
            }
            this.conditionSave();
            //数据加载
            this.$parent.dataAjax();
        },
        disabledDate(time){
            let day = this.$parent.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if(time.getTime() > new Date().getTime() || time.getTime() < number) return true;
            //if(time.getTime() > new Date().getTime()) return true;
        },
        // 条件存储sessionStorage
        conditionSave () {
            let that = this;
            let timeRanges = '';
            let time = JSON.parse(sessionStorage.getItem('myInfor')) ? JSON.parse(sessionStorage.getItem('myInfor')).time : '';
            if(that.timeType === 4){
                let timeRange = that.timeRange;
                timeRanges = [
                    that.$utils.dateConversion(timeRange[0],1),
                    that.$utils.dateConversion(timeRange[1],1)
                ];
            }else{
                if(time !== ''){
                    timeRanges = time;
                }
            }
            // let time = [that.$utils.dateConversion(timeRange[0],1),that.$utils.dateConversion(timeRange[1],1)];
			let condition = {
                pt:that.platformCondition,
                dq:that.jianRegion,
                timeType:that.timeType,
                isFocus:that.source,
                time:timeRanges
            };
            sessionStorage.setItem('myInfor', JSON.stringify(condition));   
        },
        //媒体选择
        mediaSelect (name) {
            let that = this;
            if(name === '全部'){
                name = '';
            }
            that.$parent.mediaLevel = name;
            that.platformCondition = name;//存储平台参数
            this.conditionSave();
            this.$parent.endDate_ = this.$utils.getNowDate();
            //数据加载
            that.$parent.dataAjax();
        },
        // 获取屏蔽词
        getShieldWords () {
            let that = this;
            that.$api.get('monitor/analysis/remove-words', {sid:that.planId}, r =>{
                that.$utils.returnCode(r,function(){
                    that.$parent.shieldKeywords = r.data;
                });
            })
        },
        // 列表跳转
        listJump (type,searchWords) {
            let query = {
                type:type,
                searchWords:searchWords,
                mediaLevel:this.$parent.mediaLevel,
                platformType:this.$parent.mediaPlatform,
                pubArea:this.$parent.pubArea,
                startDate:this.$parent.startDate,
                endDate:this.$parent.endDate,
				isFocus:this.source
            };
            let routeData = this.$router.resolve({ path:'/analysis/analysisDetail',query:query});
            window.open(routeData.href, '_blank');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/propagationAnalysis/analysisHeader.vue